import axios from 'axios'
import mime from 'mime'
import config from '../assets/js/config'
import {Message} from 'element-ui'
/* eslint-disable */
export default {
  methods: {
    downFile (filename = '') {
      axios.get(config.picAddr + 'web/web/down', {
        params: {filename},
        responseType: 'arraybuffer'
      }).then(res => {
        let fileName = filename.substr(filename.lastIndexOf('/') + 1)
        if (res.status == 200) {
          let blob = new Blob([res.data], {
            type: mime.getType(filename)
          })
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName)
          } else {
            let link = document.createElement("a")
            let evt = document.createEvent("HTMLEvents")
            evt.initEvent("click", false, false)
            link.href = URL.createObjectURL(blob)
            link.download = fileName
            link.style.display = "none"
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
        } else {
          Message({
            message: '下载失败,资源不存在或服务器错误',
            type: 'error',
            duration: 5 * 1000
          })
        }
      }).catch(() => {
        Message({
          message: '下载失败,资源不存在或服务器错误',
          type: 'error',
          duration: 5 * 1000
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/common.js